export function now(): number {
  if ((typeof performance !== 'undefined' && performance !== null) && performance.now) {
    return performance.now();
  } else if (Date.now) {
    return Date.now();
  }

  return new Date().getTime();
}